<template>
    <div>
      <b-modal
        ref="modalExportarDre"
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        id="modal-tipo-exportar"
        title="Exportar DRE"
      >
      <div class="grupo-exportar">
        <h4>Escolha uma opção:</h4>
        <el-radio v-model="tipoExportar" label="1" border>
          <i class="fas fa-file-export g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Padrão</b></p>
            <p class="g-text"> Exportar em formato <b>DRE</b> </p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="5" border>
          <i class="fas fa-file-export g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Padrão - Mostrar CCs Separados</b></p>
            <p class="g-text"> Exportar em formato <b>DRE</b> por Centro de Custos</p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="2" border>
          <i class="fas fa-table g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Tabela - diversos arquivos</b></p>
            <p class="g-text"> Diversos arquivos (1 para cada grupo) </p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="3" border>
          <i class="fas fa-file-alt g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Tabela - Arquivo único</b></p>
            <p class="g-text"> Arquivo único (1 com todos os grupos) </p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="4" border>
          <i class="fas fa-tasks g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Tabela - Todas as linhas</b></p>
            <p class="g-text"> Arquivo único com linhas de cálculo </p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="7" border>
          <i class="fas fa-tasks g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Tabela - Todas as linhas com detalhes</b></p>
            <p class="g-text"> Arquivo único com linhas de cálculo e detalhes </p>
          </div>
        </el-radio>
        <el-radio v-model="tipoExportar" label="6" border>
          <i class="fas fa-tasks g-icon"></i>
          <div class="g-right">
            <p class="g-title"><b>Detalhes Multiplos</b></p>
            <p class="g-text"> Arquivo único com todos detalhes de rateio</p>
          </div>
        </el-radio>
      </div>
      <div class="grupo-exportar">
        <div v-if="this.tipoExportar == '6'">
          <h4>Filtros Adicionais:</h4>
        </div>
        <b-form-group v-if="this.tipoExportar == '6'" id="linhaValores" label="Linha da DRE:" label-for="linhaValoresSelect" label-size="sm">
          <div class="d-flex align-items-center" label="Linha da DRE:">
              <select2Multiple required 
                  :options="linhas" 
                  name="linhaValoresSelect" 
                  v-model="model.linhasIds"
                  :refresh="true">
              </select2Multiple>
          </div>
        </b-form-group>
      </div>
        <template #modal-footer="{ hide }">
          <div class="float-right">
            <el-button size="small" @click="hide()">Fechar</el-button>
            <el-button type="primary" size="small" @click="exportar">Exportar</el-button>
          </div>
        </template>
      </b-modal>
    </div>
  </template>
  
  <script>

import Select2Multiple from '@/components/shared/Select2Multiple';

const model = () => {
  return { 
    linhasIds: [],
    addDetalhes: false
  }
}

  export default {
    components: {
        Select2Multiple
    },
    name: 'ModalExportar',
    props: ['modeloId'],
    data () {
      return {
        tipoExportar: '1',
        model : model(),
        linhas: [],
      }
    },
    methods: {
      exportar() {
        if(!this.$parent.isValidDRE()) {
          this.$notify.error({
						title: 'Erro ao exportar',
						message: `Por favor, configure os filtros para exportar.`,
						position:'top-left'
					});
          return
        }
        switch(this.tipoExportar)  {
          case '1': this.$parent.exportarDRE(); break;
          case '2': this.$parent.exportarParaSistema(); break;
          case '3': this.$parent.exportarParaSistemaAntigo(); break;
          case '4': this.$parent.exportarParaSistemaComTodasLinhas(); break;
          case '5': this.$parent.exportarDREPorCCs(); break;
          case '6': this.$parent.exportarDetalhesMultiplos(this.model); break;
          case '7': this.$parent.exportarParaSistemaComTodasLinhasEDetalhes(); break;
        }
        this.model = model()
      }
    },
    watch: {
      'tipoExportar': function(newVal) {
        if (newVal == '6') {
          var self = this
          self.axios.get(`${self.$urls.DRE_TODAS_LINHAS}?modeloDre=${self.modeloId}`).then((dt) => {
              if(!dt){ 
                  self.linhas = []
                  return false 
              }
              self.linhas = dt.data
          })
        }
    },
    mounted() {
      this.model = model();
    }
  }
  };
  </script>
  
  <style lang="scss" scoped>
  .grupo-exportar {
    h4 { font-size:15px; }
    label.el-radio {
      width: 100%;
      padding: 0px 12px 19px;
      height: auto;
    }
    .el-radio.is-bordered+.el-radio.is-bordered {
      margin-left: 0;
    }
    .g-icon {
      border: 1px solid #ccc;
      height: 40px;
      width: 40px;
      text-align: center;
      line-height: 36px;
      border-radius: 6px;
      margin-right: 8px;
      margin-top: 15px;
    }
    .g-title {
      font-size: 15px;
    }
    .g-text {
      margin: 4px;
    }
    .g-right {
      display: inline-block;
      position: relative;
      top: 9px;
      left: 10px;
      p {
        margin:0;
      }
    }
  }
  
  </style>